import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { api, apiHolder, apis, edmWeeklyReportSpaceCode, } from 'api';
const advertApi = apiHolder.api.requireLogicalApi(apis.advertApiImpl);
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
const worktableApi = process.env.BUILD_ISLINGXI ? {} : api.requireLogicalApi('worktableApiImpl');
const defaultDateRange = {
    start_date: moment().startOf('month').format('YYYY-MM-DD'),
    end_date: moment().endOf('month').format('YYYY-MM-DD'),
};
const initState = {
    schedule: {
        loading: false,
        showModal: false,
        filters: Object.assign(Object.assign({}, defaultDateRange), { page: 1, page_size: 10 }),
    },
    memberOptionList: undefined,
    memberList: undefined,
    customerFunnel: {
        edmPlanNum: {},
        potentialTaskNum: {},
        potentialCustomerNum: {},
        isWatchingPotentialCustomer: undefined,
    },
    dataOverview: {
        edmWeeklyReportUrl: {},
        marketingAll: {},
        pk: {},
        customerDataAll: {},
        edmAll: {},
        edmMy: {},
        marketingMy: {},
        customerDataMy: {},
        mailMy: {},
        systemUsage: {},
    },
    emailInquirySwitch: {
        loading: false,
        showModal: false,
        filters: defaultDateRange,
    },
    enhancePotentialReplyHint: undefined,
};
export const getEmailInquirySwitchAsync = createAsyncThunk('getEmailInquirySwitchAsync', () => {
    return worktableApi.getEmailInquirySwitch();
});
export const fetchSystemUsageData = createAsyncThunk('worktableReducer/fetchSystemUsageData', () => {
    return worktableApi.getSysUsageView();
});
export const fetchMarketingAll = createAsyncThunk('worktableReducer/fetchMarketingAllData', (params) => {
    return edmApi.fetchDeliverCenterPrivilegeOverviewData(1, params === null || params === void 0 ? void 0 : params.searchDate, params === null || params === void 0 ? void 0 : params.accountIds);
});
export const fetchMarketingMy = createAsyncThunk('worktableReducer/fetchMarketingMy', (params) => {
    return edmApi.fetchDeliverCenterOverviewData(1, params === null || params === void 0 ? void 0 : params.searchDate);
});
export const fetchMailData = createAsyncThunk('worktableReducer/fetchMailData', (params) => {
    return worktableApi.getEmailPanel(params);
});
export const fetchPkData = createAsyncThunk('worktableReducer/fetchPkData', (params) => {
    return worktableApi.getEmployeePkList({
        page: 0,
        pageSize: 0,
        searchAccIds: params.searchAccIds,
        searchDateScope: params.searchDateScope,
        sort: params.sortType,
    });
});
export const fetchEdmWeeklyReportUrl = createAsyncThunk('worktableReducer/fetchEdmWeeklyReportUrl', async () => {
    var _a, _b, _c;
    const response = await advertApi.fetchConfig(edmWeeklyReportSpaceCode);
    if ((_a = response.data) === null || _a === void 0 ? void 0 : _a.itemList) {
        const temp = response.data.itemList || [];
        const advertResourceList = (_b = temp[0]) === null || _b === void 0 ? void 0 : _b.advertResourceList;
        const conf = advertResourceList ? advertResourceList[0] : undefined;
        if ((_c = conf === null || conf === void 0 ? void 0 : conf.content) === null || _c === void 0 ? void 0 : _c.clickUrl) {
            return conf === null || conf === void 0 ? void 0 : conf.content.clickUrl;
        }
        return '';
    }
    return '';
});
export const fetchMyEdmData = createAsyncThunk('worktableReducer/fetchMyEdmData', (filter) => {
    return worktableApi.getEdmPanel(filter);
});
export const fetchAllEdmData = createAsyncThunk('worktableReducer/fetchAllEdmData', (params) => {
    return worktableApi.getAllEdmPanel(params);
});
export const fetchMyCustomerData = createAsyncThunk('worktableReducer/fetchMyCustomerData', async (params) => {
    return worktableApi.getCustomerPanel(params);
});
export const fetchAllCustomerData = createAsyncThunk('worktableReducer/fetchAllCustomerData', async (params) => {
    return worktableApi.getAllCustomerPanel(params);
});
export const getSchedulePanelAsync = createAsyncThunk('getSchedulePanelAsync', (filter) => {
    return worktableApi.getSchedulePanel(filter);
});
export const getIsWatchingPotentialCustomer = createAsyncThunk('worktableReducer/getIsWatchingPotentialCustomer', () => {
    return worktableApi.intentionalCustomerRule();
});
export const getEdmPlanNum = createAsyncThunk('worktableReducer/getEdmPlanNum', async (accId) => {
    const result = await edmApi.getEdmPlanCount(accId);
    if (result) {
        if (!result.permission) {
            return {
                accId,
                result: {
                    permission: false,
                    planCount: null,
                    autoPlanCount: null,
                    allContactCount: null,
                },
            };
        }
        return { accId, result };
    }
    return { accId, result };
});
export const getPotentialCustomerNum = createAsyncThunk('worktableReducer/getPotentialCustomerNum', async (accId) => {
    const result = await worktableApi.intentionalCustomerNum(accId);
    return { accId, result };
});
export const getPotentialTask = createAsyncThunk('worktableReducer/getPotentialTask', async (accId) => {
    const result = await edmApi.getEdmPotentialCount(accId);
    if (result) {
        if (!result.permission) {
            return {
                accId,
                result: {
                    permission: false,
                    planCount: null,
                    potentialAddCount: null,
                },
            };
        }
        return { accId, result };
    }
    return { accId, result };
});
export const getWorktableMemberList = createAsyncThunk('worktableReducer/getWorktableMemberList', async () => {
    const result = await worktableApi.memberOptionListAll();
    if (result) {
        return Object.keys(result).reduce((total, key) => {
            total[key] = (result[key] || []).map(v => ({ label: v.name, value: String(v.accId) }));
            return total;
        }, {});
    }
    return { FUNNEL: [], PK: [], TEAM: [], TEAM_EDM: [], TEAM_CONTACT: [] };
});
export const getMarketingEffectMemberList = createAsyncThunk('worktableReducer/geMarketingEffectMemberList', async () => {
    const result = await edmApi.fetchDeliverCenterPrivilegeAccounts();
    if (result) {
        return (result.accountList || []).map(item => ({
            label: item.accountName,
            value: item.accountId,
        }));
    }
    return [];
});
const worktableSlicer = createSlice({
    name: 'worktableReducer',
    initialState: initState,
    reducers: {
        updateMemberList: (state, action) => {
            state.memberList = action.payload;
        },
        updateEnhancePotentialReplyHint: (state, action) => {
            state.enhancePotentialReplyHint = action.payload;
        },
        clearCustomerFunnel: state => {
            state.customerFunnel = {
                edmPlanNum: {},
                potentialTaskNum: {},
                potentialCustomerNum: {},
                isWatchingPotentialCustomer: undefined,
            };
        },
        clearDataOverview: (state, action) => {
            const forWholeData = action.payload;
            state.dataOverview = {
                edmWeeklyReportUrl: forWholeData ? {} : state.dataOverview.edmWeeklyReportUrl,
                marketingAll: {},
                pk: {},
                customerDataAll: {},
                edmAll: {},
                edmMy: {},
                marketingMy: {},
                customerDataMy: {},
                mailMy: {},
                systemUsage: {},
            };
        },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchMailData.pending, state => {
            state.dataOverview.mailMy.loading = true;
        })
            .addCase(fetchMailData.fulfilled, (state, action) => {
            state.dataOverview.mailMy = { loading: false, data: action.payload };
        })
            .addCase(fetchMailData.rejected, state => {
            state.dataOverview.mailMy.loading = false;
        });
        builder
            .addCase(fetchPkData.pending, state => {
            state.dataOverview.pk.loading = true;
        })
            .addCase(fetchPkData.fulfilled, (state, action) => {
            state.dataOverview.pk = { loading: false, data: action.payload.content || [] };
        })
            .addCase(fetchPkData.rejected, state => {
            state.dataOverview.pk.loading = false;
        });
        builder
            .addCase(fetchEdmWeeklyReportUrl.pending, state => {
            state.dataOverview.edmWeeklyReportUrl.loading = true;
        })
            .addCase(fetchEdmWeeklyReportUrl.fulfilled, (state, action) => {
            state.dataOverview.edmWeeklyReportUrl = { loading: false, data: action.payload };
        })
            .addCase(fetchEdmWeeklyReportUrl.rejected, state => {
            state.dataOverview.edmWeeklyReportUrl.loading = false;
        });
        builder
            .addCase(fetchMyEdmData.pending, state => {
            state.dataOverview.edmMy.loading = true;
        })
            .addCase(fetchMyEdmData.fulfilled, (state, action) => {
            state.dataOverview.edmMy = { loading: false, data: action.payload };
        })
            .addCase(fetchMyEdmData.rejected, state => {
            state.dataOverview.edmMy.loading = false;
        });
        builder
            .addCase(fetchAllEdmData.pending, state => {
            state.dataOverview.edmAll.loading = true;
        })
            .addCase(fetchAllEdmData.fulfilled, (state, action) => {
            state.dataOverview.edmAll = { loading: false, data: action.payload };
        })
            .addCase(fetchAllEdmData.rejected, state => {
            state.dataOverview.edmAll.loading = false;
        });
        builder
            .addCase(fetchMyCustomerData.pending, state => {
            state.dataOverview.customerDataMy.loading = true;
        })
            .addCase(fetchMyCustomerData.fulfilled, (state, action) => {
            state.dataOverview.customerDataMy = { loading: false, data: action.payload };
        })
            .addCase(fetchMyCustomerData.rejected, state => {
            state.dataOverview.customerDataMy.loading = false;
        });
        builder
            .addCase(fetchAllCustomerData.pending, state => {
            state.dataOverview.customerDataAll.loading = true;
        })
            .addCase(fetchAllCustomerData.fulfilled, (state, action) => {
            state.dataOverview.customerDataAll = { loading: false, data: action.payload };
        })
            .addCase(fetchAllCustomerData.rejected, state => {
            state.dataOverview.customerDataAll.loading = false;
        });
        builder
            .addCase(getSchedulePanelAsync.pending, state => {
            state.schedule.loading = true;
        })
            .addCase(getSchedulePanelAsync.fulfilled, (state, action) => {
            state.schedule.loading = false;
            state.schedule.data = action.payload;
        })
            .addCase(getSchedulePanelAsync.rejected, state => {
            state.schedule.loading = false;
        });
        builder
            .addCase(getEmailInquirySwitchAsync.pending, state => {
            state.emailInquirySwitch.loading = true;
        })
            .addCase(getEmailInquirySwitchAsync.fulfilled, (state, action) => {
            state.emailInquirySwitch.loading = false;
            state.emailInquirySwitch.data = action.payload;
        })
            .addCase(getEmailInquirySwitchAsync.rejected, state => {
            state.emailInquirySwitch.loading = false;
        });
        builder.addCase(getWorktableMemberList.fulfilled, (state, action) => {
            const TARGETS = ['FUNNEL', 'PK', 'TEAM', 'TEAM_EDM', 'TEAM_CONTACT'];
            TARGETS.forEach(key => {
                var _a;
                if (!state.memberOptionList) {
                    state.memberOptionList = {};
                }
                state.memberOptionList[key] = (_a = action.payload[key]) !== null && _a !== void 0 ? _a : [];
            });
        });
        builder.addCase(getMarketingEffectMemberList.fulfilled, (state, action) => {
            if (!state.memberOptionList) {
                state.memberOptionList = {};
            }
            state.memberOptionList.TEAM_MARKETING = action.payload;
        });
        builder.addCase(getEdmPlanNum.fulfilled, (state, action) => {
            const { result, accId } = action.payload;
            if (result) {
                const memberId = accId || 'own';
                state.customerFunnel.edmPlanNum[memberId] = result;
            }
        });
        builder.addCase(getPotentialTask.fulfilled, (state, action) => {
            const { result, accId } = action.payload;
            if (result) {
                const memberId = accId || 'own';
                state.customerFunnel.potentialTaskNum[memberId] = result;
            }
        });
        builder.addCase(getPotentialCustomerNum.fulfilled, (state, action) => {
            const { result, accId } = action.payload;
            const memberId = accId || 'own';
            state.customerFunnel.potentialCustomerNum[memberId] = result;
        });
        builder.addCase(getIsWatchingPotentialCustomer.fulfilled, (state, action) => {
            const { newCustomerNotifyRule, notReplyNotFollowNotifyRule } = action.payload || {};
            state.customerFunnel.isWatchingPotentialCustomer = !!((newCustomerNotifyRule === null || newCustomerNotifyRule === void 0 ? void 0 : newCustomerNotifyRule.open) || (notReplyNotFollowNotifyRule === null || notReplyNotFollowNotifyRule === void 0 ? void 0 : notReplyNotFollowNotifyRule.open));
        });
        builder
            .addCase(fetchSystemUsageData.pending, state => {
            state.dataOverview.systemUsage.loading = true;
        })
            .addCase(fetchSystemUsageData.fulfilled, (state, action) => {
            state.dataOverview.systemUsage = { loading: false, data: action.payload };
        })
            .addCase(fetchSystemUsageData.rejected, state => {
            state.dataOverview.systemUsage.loading = false;
        });
        builder
            .addCase(fetchMarketingAll.pending, state => {
            state.dataOverview.marketingAll.loading = true;
        })
            .addCase(fetchMarketingAll.fulfilled, (state, action) => {
            state.dataOverview.marketingAll = { loading: false, data: action.payload };
        })
            .addCase(fetchMarketingAll.rejected, state => {
            state.dataOverview.marketingAll.loading = false;
        });
        builder
            .addCase(fetchMarketingMy.pending, state => {
            state.dataOverview.marketingMy.loading = true;
        })
            .addCase(fetchMarketingMy.fulfilled, (state, action) => {
            state.dataOverview.marketingMy = { loading: false, data: action.payload };
        })
            .addCase(fetchMarketingMy.rejected, state => {
            state.dataOverview.marketingMy.loading = false;
        });
    },
});
export const { actions } = worktableSlicer;
export default worktableSlicer.reducer;
